export const isValidEmail = (email) => {
    const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email.toLowerCase());
};
export const isValidPhoneNumber = (phoneNumber) => {
    //The number starts with +, contains numbers, is of length between 1  and 14
    const regex = /^\+[1-9]{1}[0-9]{1,14}$/;
    return regex.test(phoneNumber);
};
export const isValidSensorTagName = (tagName) => {
    const regex = /^[a-zA-Z0-9\.\_]{1,}$/;
    return regex.test(tagName);
};
export const containsPipeSymbol = (text) => {
    const regex = /[|]/;
    return regex.test(text);
};
export const isValidFloatNumber = (text) => {
    var regex = /^-?\d+\.?\d*$/;
    return regex.test(text);
};
